import { render } from "./List2.vue?vue&type=template&id=46a0b7dc"
import script from "./List2.vue?vue&type=script&lang=ts"
export * from "./List2.vue?vue&type=script&lang=ts"

import "./List2.vue?vue&type=style&index=0&id=46a0b7dc&lang=scss"
script.render = render

export default script